// Reads a claim from a JWT's payload without verifying it; the API verifies the token on every call.
export function jwtClaim(jwt: string | null | undefined, claim: string): string | null {
  try {
    const payload = jwt!.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(payload))[claim] ?? null;
  } catch {
    return null;
  }
}
